'use client';

import { useEffect, useState } from 'react';

/** Viewport orientation follows phone rotation and resized desktop windows. */
export function useHomepageVideoOrientation() {
  const [portrait, setPortrait] = useState<boolean | null>(null);
  useEffect(() => {
    const query = window.matchMedia('(orientation: portrait)');
    const update = () => setPortrait(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return portrait;
}
